import debug from "debug";
import * as THREE from "three";

const log = debug("app:cameraswap");

class CameraSwap {
    private experience: any;
    private camera: THREE.PerspectiveCamera;
    private controls: any;
    private scene: THREE.Scene;
    private eventHub: any;

    constructor(experience: any) {
        this.experience = experience;
        this.camera = experience.camera.instance;
        this.controls = experience.camera.controls;
        this.scene = experience.scene;
        this.eventHub = this.experience.eventHub;

        log("Controls:", this.controls);
        this.initListeners();
    }

    cleanup() {
        this.eventHub.off("viewChange", this.handleViewChange);
    }

    initListeners() {
        this.eventHub.on("viewChange", (view: string) => this.handleViewChange(view));
    }

    private handleViewChange(view: string) {
        const views: Record<string, THREE.Vector3> = {
            top: new THREE.Vector3(0, 1, 0),
            bottom: new THREE.Vector3(0, -1, 0),
            front: new THREE.Vector3(0, 0, 1),
            back: new THREE.Vector3(0, 0, -1),
            left: new THREE.Vector3(-1, 0, 0),
            right: new THREE.Vector3(1, 0, 0),
            isometric: new THREE.Vector3(1, 1, 1).normalize()
        };

        if (views[view]) {
            this.setView(views[view]);
            log(`View changed to: ${view}`);
        } else {
            log(`Invalid view name: ${view}`);
        }
    }

    private setView(direction: THREE.Vector3) {
        const offset = this.camera.position.clone().sub(this.controls.target);
        const distance = offset.length();

        this.camera.position.copy(this.controls.target).addScaledVector(direction, distance);
        this.camera.up.set(0, 1, 0);
        this.camera.lookAt(this.controls.target);
        this.camera.updateProjectionMatrix();
        this.controls.update();
    }

}

export default CameraSwap;
